import {Injectable} from "@angular/core";
import {RequesterService} from "../../../shared/services/requester/requester.service";
import * as fromStore from "../../../store";
import {DbStoreState} from "../../../store";
import {Store} from "@ngrx/store";
import {combineLatest, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";

@Injectable()
export class EcommercePaymentsService {
  private _ownerWorkspaceId: number;
  private _currentWorkspaceId: number;

  constructor(private _requester: RequesterService,
              private _httpClient: HttpClient,
              private _googleAnalyticsService: GoogleAnalyticsService,
              private _store: Store<DbStoreState>) {
    this._getWorkspaceEntities();
  }

  private _getWorkspaceEntities(): void {
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getWorkspaceIdEntities)
    ).subscribe(([userSubscription, workspaceIdEntities]) => {
      this._ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this._currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this._ownerWorkspaceId;
    });
  }

  createMerchant(liveEnv: boolean): Observable<any> {
    let data = {};
    if (!liveEnv) {
      data = Object.assign({}, data, {
        fillData: true,
      });
    }
    const env = !!liveEnv ? 'live' : 'test';

    return this._requester.woocomPayments
      .post(`workspaces/${this._currentWorkspaceId}/merchants/${env}/create`, null, data);
  }

  getDomainMerchants(domainID: number) {
    return this._requester.woocomPayments
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainID}/merchants/my`, null, true);
  }
/*
  getWorkspaceMerchants() {
    return this._requester.woocomPayments
      .get(`workspaces/${this._currentWorkspaceId}/merchants/my`, null, true);
  }*/

  getWorkspaceMerchants() {
    return this._requester.tenWebStripe
      .get(`workspaces/${this._currentWorkspaceId}/accounts?force=1`, null, true);
  }

  getMerchantHash(merchantId: string, env: string) {
    return this._requester.woocomPayments
      .get(`workspaces/${this._currentWorkspaceId}/merchants/${merchantId}/${env}/get-merchant-hash`, null, true);
  }


  getDomainPendingPayouts(merchantId: string, env: string) {
    return this._requester.woocomPayments
      .get(`workspaces/${this._currentWorkspaceId}/merchants/${merchantId}/${env}/pending-payouts`, null, true);
  }

  connectMerchant(domainId: number, merchantId: string, env: string) {
    return this._requester.woocomPayments
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/merchants/${merchantId}/${env}/connect`, null, true);
  }


  updateTestMode(domainID: number) {
    return this._requester.woocomPayments
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=payment_test_mode`, null, true);
  }


  createStripeAccount(accountType: string, websiteId = null): Observable<any> {
    const data = {"fillData": true};

    if (websiteId && localStorage.getItem('my_site_is_not_prohibited_confirmation' + websiteId)) {
      data['my_site_is_not_prohibited_confirmation'] = true;
    }
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/accounts/${accountType}/create`, null, data, true);
  }

  createConnectStripeAccount(accountType: string, websiteId = null): Observable<any> {
    const data = {"fillData": true};

    if (websiteId && localStorage.getItem('my_site_is_not_prohibited_confirmation' + websiteId)) {
      data['my_site_is_not_prohibited_confirmation'] = true;
    }
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/domains/${websiteId}/${accountType}/accounts/create`, null, data, true);
  }

  connectStripeAccountToDomain(accountType: string, accountId: string, domainId: number): Observable<any> {
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/${accountType}/accounts/${accountId}/connect`, null, null, true, false, false);
  }

  disconnectStripeAccountToDomain(accountType: string, accountId: string, domainId: number): Observable<any> {
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/${accountType}/accounts/${accountId}/disconnect`, null, null, true, false, false);
  }

  createAccountSession(accountType: string, accountId: string): Observable<any> {
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/${accountType}/accounts/${accountId}/create_account_session`, null, null, true);
  }

  createAccountLink(accountType: string, accountId: string, domainId): Observable<any> {
    return this._requester.tenWebStripe
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/${accountType}/accounts/${accountId}/create_account_link`, null, true);
  }

  getPublicKey(domainId: number): Observable<any> {
    return this._requester.tenWebStripe
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/get_public_key`, null, null);
  }

  getStripeAccount(domainId: number): Observable<any> {
    return this._requester.tenWebStripe
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainId}/accounts?force=1`, null, true);
  }

  getPaymentMethodConfiguration(accountType: string, workspaceId: number, domainId: number, accountId: string, ): Observable<any> {
    return this._requester.tenWebStripe
      .get(`workspaces/${workspaceId}/domains/${domainId}/${accountType}/accounts/${accountId}/payment-method-configuration`, null, true);
  }

  updatePaymentMethodConfiguration(accountType: string, workspaceId: number, domainId: number, accountId: string, config: {
    apple_pay?: boolean;
    google_pay?: boolean;
  }): Observable<any> {
    return this._requester.tenWebStripe
      .post(`workspaces/${workspaceId}/domains/${domainId}/${accountType}/accounts/${accountId}/payment-method-configuration`, null, config, true);
  }

}
